import {keepBrandTogether} from './broil-king-brand-text.js?v=20261012';
/* Shared standard renderer adapter: existing controls and native cart action remain authoritative. */
import {mountPurchaseComponents} from './napoleon-ui.js?shipping-stock-20261027';
import {bundleTotal,purchaseBenefitsData} from './hop-purchase.js?shipping-stock-20261027';
let cleanup;
const inclusionCache = new Map();
async function mount() {
  cleanup?.(); cleanup = null;
  const root = document.querySelector('.fm-page[data-hop-purchase]');
  const source = root?.querySelector('#hop-purchase-data');
  if (!source) return;
  root.setAttribute('data-hop-purchase','');
  const data = JSON.parse(source.textContent);
  if(root.dataset.brand==='Broil King')data.product={...data.product,shipping_heading:'FREE Shipping',shipping_summary:'Shipping is FREE. We ship within the United States, excluding Alaska and Hawaii. Your order confirmation and tracking information will keep you updated on delivery.'};
  const form = root.querySelector('#fire-magic-product-form') || root.querySelector('.fm-buy form');
  const buy = root.querySelector('.fm-buy');
  if (!form || !buy) return;
  // Legacy pages without a standard profile reuse only the native cart handler.
  if (!document.querySelector('[data-hx27-pilot]')) {
    const {setupAddons} = await import('./hx27-pdp-standard.js?v=20261001-fm-1');
    if (!root.isConnected) return;
    setupAddons(root);
  }
  const brandObserver = root.dataset.brand === 'Broil King' ? keepBrandTogether(root.closest('main') || root) : null;
  const price = document.createElement('div'); price.dataset.hopPriceHost = '';
  const benefits = document.createElement('div'); benefits.dataset.hopBenefitsHost = '';
  const sticky = document.createElement('div'); sticky.dataset.hopStickyHost = '';
  buy.querySelector('.fm-price').append(price); buy.querySelector('.fm-price').after(benefits); root.append(sticky);
  const renderer = mountPurchaseComponents({price,benefits,sticky});
  const pilot = root.hasAttribute('data-paid-pdp-pilot');
  const totalHost = pilot ? document.createElement('div') : null;
  if(totalHost){
    totalHost.className='setup-total'; totalHost.dataset.pilotSetup='';
    totalHost.innerHTML='<div><span>Core product</span><span data-pilot-base></span></div><div><span data-pilot-extra-label></span><span data-pilot-extras></span></div><div class="setup-total-final"><strong>Setup total</strong><strong data-pilot-total></strong></div>';
    form.querySelector('.fm-commerce').before(totalHost);
  }
  const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
  let active = true, frame, busy = false, addedSignature = '', pendingSignature = '';
  const findWarranty = () => {
    const target = root.querySelector('#warranty,#accessory-warranty') || [...root.querySelectorAll('.fm-accordion details')].find(detail => /warranty/i.test(detail.querySelector('summary')?.textContent || ''));
    if (target && !target.id) target.id = 'hop-purchase-warranty';
    return target;
  };
  const scrollTo = target => {
    if (!target) return;
    if (target.matches('details')) target.open = true;
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    target.querySelector('summary,button,input,a')?.focus({preventScroll:true});
  };
  const read = () => {
    const id = String(form.elements.id.value);
    const entry = Object.entries(data.variants).find(([,variant])=>String(variant.id)===id);
    const [sku,variant] = entry || ['',{}];
    const quantity = Math.max(1,Number(form.elements.quantity?.value)||1);
    const lines = [{sku:id,quantity,unitCents:variant.price ?? null}];
    for (const input of root.querySelectorAll('[data-hx27-addon]:checked')) {
      let item; try {item=JSON.parse(input.dataset.item);} catch {lines.push({sku:'unresolved',quantity:1,unitCents:null});continue;}
      // Match setupAddons' existing accessory quantity semantics exactly.
      const multiplied = item.required || ['appliance','component'].includes(document.querySelector('[data-hx27-pilot]')?.dataset.categoryProfile);
      lines.push({sku:String(item.id),quantity:multiplied?quantity:1,unitCents:Number.isFinite(item.price)?item.price:null,required:!!item.required||!!input.dataset.requiredCart});
    }
    const accessoryCount = root.querySelectorAll('[data-hx27-addon]:checked:not([data-required-cart])').length;
    return {sku,variant,id,quantity,lines,accessoryCount};
  };
  const render = () => {
    frame = null; if (!active) return;
    const {sku,variant,id,quantity,lines,accessoryCount} = read();
    const warranty = findWarranty();
    const options = root.querySelector('.fm-options,.fm-family-options');
    const accessories = root.querySelector('.hx27-finishing');
    const ratings = buy.querySelector('.hop-rating-links');
    // Ratings are mounted asynchronously by the existing review component.
    if(ratings && ratings.nextElementSibling !== benefits) ratings.after(benefits);
    const button = form.querySelector('[type="submit"]');
    const purchasable = variant.available !== false && Number.isFinite(variant.price);
    if (!busy && !purchasable && !button.disabled) button.disabled = true;
    const category = root.dataset.purchaseCategory;
    if(totalHost){
      const total=bundleTotal(lines),base=bundleTotal(lines.filter((line,index)=>index===0||line.required)),extras=bundleTotal(lines.filter((line,index)=>index>0&&!line.required));
      totalHost.querySelector('[data-pilot-base]').textContent=base===null?'Price on request':money(base);
      totalHost.querySelector('[data-pilot-extra-label]').textContent='Optional extras · '+accessoryCount+' selected';
      totalHost.querySelector('[data-pilot-extras]').textContent=extras===null?'Price on request':money(extras);
      totalHost.querySelector('[data-pilot-total]').textContent=total===null?'Price on request':money(total);
      const expert=root.querySelector('[data-pilot-expert]');
      if(expert){const url=new URL('/pages/customer-care',location.origin);url.searchParams.set('product',root.dataset.productHandle);url.searchParams.set('variant',id);url.searchParams.set('sku',sku);url.hash='contact';expert.href=url.href;}
    }
    const benefitData=purchaseBenefitsData(data,category,root.dataset.productHandle,sku);
    if(pilot)benefitData.shipping_note='Delivery timing and availability are confirmed with your order.';
    renderer.render({
      price:{data:benefitData,variantId:id,unitPriceCents:variant.price},
      benefits:{data:benefitData,warranty:!!warranty,warrantyTarget:warranty ? '#'+warranty.id : undefined,openWarranty:()=>scrollTo(warranty)},
      sticky:{title:buy.querySelector('h1').textContent,sku,quantity,lines,
        hasOptions:!!options,hasAccessories:!!root.querySelector('[data-hx27-addon]:not([data-required-cart])'),accessoryCount,
        busy,addedSignature,available:variant.available,cartUrl:data.cart_url,variantId:id=>id,
        rootSelector:'.fm-page[data-hop-purchase]',purchaseSelector:pilot?'.fm-price':'.fm-commerce',
        editTarget:()=>scrollTo(options||accessories),
        onAdd:()=>{
          if(busy||!purchasable||!button)return;
          // The native success state can remain disabled after a cart removal.
          if(button.disabled&&button.textContent.trim()==='Added')button.disabled=false;
          if(!button.disabled)form.requestSubmit(button);
        }}
    });
  };
  const schedule = () => {if(active&&!frame)frame=requestAnimationFrame(render);};
  const cartState = event => {
    const currentSignature=JSON.stringify(read().lines.map(({sku,quantity})=>({sku,quantity})));
    busy=event.detail.state==='pending';
    if(busy)pendingSignature=currentSignature;
    if(event.detail.state==='added'){
      addedSignature=pendingSignature;
      if(currentSignature!==pendingSignature){const button=form.querySelector('[type=submit]');button.disabled=false;button.textContent='Add to Cart';}
    }
    if(event.detail.state==='error')addedSignature='';
    schedule();
  };
  root.addEventListener('change',schedule);root.addEventListener('input',schedule);root.addEventListener('click',schedule);root.addEventListener('hop:cart-state',cartState);
  // Observe native controls/ratings only; never observe React's own rendered hosts.
  const observer = new MutationObserver(records=>{if(records.some(record=>!record.target.closest?.('[data-hop-price-host],[data-hop-benefits-host],[data-hop-sticky-host],[data-pilot-setup]')))schedule();});
  observer.observe(buy,{childList:true,subtree:true,attributes:true,attributeFilter:['data-item','disabled']});
  cleanup=()=>{brandObserver?.disconnect();active=false;cancelAnimationFrame(frame);observer.disconnect();root.removeEventListener('change',schedule);root.removeEventListener('input',schedule);root.removeEventListener('click',schedule);root.removeEventListener('hop:cart-state',cartState);const payment=price.querySelector('#hop-purchase-payment-form');if(payment){payment.hidden=true;root.querySelector('[data-hop-payment-source]')?.append(payment);}renderer.unmount();price.remove();benefits.remove();sticky.remove();totalHost?.remove();};
  render();
  if(!inclusionCache.has(data.inclusions_url))inclusionCache.set(data.inclusions_url,fetch(data.inclusions_url).then(response=>response.ok?response.json():null).catch(()=>null));
  data.inclusions=await inclusionCache.get(data.inclusions_url);schedule();
}
// Mark early so the standard renderer binds its existing combined-cart handler on enabled products.
const initial=document.querySelector('.fm-page[data-hop-purchase]:has(#hop-purchase-data)');
initial?.setAttribute('data-hop-purchase','');
mount();document.addEventListener('hx27:model-ready',mount);
